module.exports = __webpack_public_path__ + "static/media/Yaoua_desktop_article_7.3b981ce8.jpg";